import React from 'react';

type DeleteProps = {
  onClose: () => void;
  modal: boolean;
  deleteFunction: () => void;
  row: NotificationRow;
};
const DeleteModal = ({ row, onClose, modal, deleteFunction: functionToRun } : DeleteProps) => {
  if (!modal) {
    return;
  }

  const handleClose = event => {
    if (event.target.matches('.inset-0')) {
      onClose();
    }
  };

  return (
    <button
      className="fixed inset-0 bg-gray-400 bg-opacity-25 z-2000 flex flex-col justify-center items-center"
      onClick={handleClose}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          handleClose(event);
        }
      }}
      data-testid="modal-div"
      role="button"
      >
      <div className="max-w-lg w-full fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex bg-white shadow-lg p-4 flex-col items-center justify-center gap-4 rounded-lg">
        <h1 className="text-center text-xl">Are you sure you want to delete --- <span className='font-bold'> {row.title} </span> Notification?</h1>
        <div className="flex items-centre justify-center w-full gap-10">
          <button
            className="bg-mannablue-default p-2 rounded-md text-white"
            onClick={event => {
              onClose();
              functionToRun();
            }}>
            Confirm
          </button>
          <button
            className="bg-mannamono-label p-2 rounded-md text-white"
            onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </button>
  );
};

export default DeleteModal;